import React from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import { makeStyles } from '@material-ui/core/styles';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: '6px 16px',
    },
    secondaryTail: {
        backgroundColor: theme.palette.secondary.main,
    },
}));

const IssueHistoryComment = ({ issue,attachments }) => {
    const classes = useStyles();
    console.log(attachments)
    const sortedComment =   issue.IssueComment.length > 0 ? issue.IssueComment.sort(function(a, b) {
  return b.CommentDate.localeCompare(a.CommentDate);
}) : []
    return (
        <div>
            { 
                
                issue.IssueComment.length > 0 ?
                <Timeline key={issue.IssueId}>
                    {                      
                
                        sortedComment.map(comment => {
                            const d = new Date(comment.CommentDate)
                            return (<TimelineItem key={Math.random()}>
                                <TimelineOppositeContent style={{ maxWidth: 200 }}>
                                    <Typography color="textSecondary">{d.toLocaleString("en-US")}</Typography>
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot variant="outlined"><ChatBubbleOutlineIcon color="disabled" /></TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Paper elevation={3} className={classes.paper}>{comment.Comment}
                                        <Typography color="textSecondary">
                                            Edited by: {comment.MadeBy}
                                        </Typography>
                                        <>
                                        {attachments && attachments.map(attachment => (
                                          
                                            attachment.id == comment.IssueCommentId && 
                                            <div><a href={attachment.url} target="_blank">{attachment.friendlyFileName}</a></div> 
                                        ))}
                                    </>
                                    </Paper>
                                </TimelineContent>
                            </TimelineItem>)
                        })
                    }
                </Timeline> : <div></div>
            }
        </div>
    );
}

export { IssueHistoryComment };